<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap"
        v-model="localVisible" :confirmLoading="loading" :maskClosable="false" :destroyOnClose="true" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ localForm.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="localForm.others" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="localForm.others.name" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="编号">
            <a-input v-model="localForm.others.number" />
          </a-form-model-item>
          <a-form-model-item prop="record_time" label="记录时间">
            <a-date-picker v-model="localForm.others.record_time" valueFormat="YYYY-MM-DD" style="width: 100%" allowClear />
          </a-form-model-item>
          <a-form-model-item prop="product_name" label="产品名称">
            <a-input v-model="localForm.others.product_name" />
          </a-form-model-item>
          <a-form-model-item prop="storage_devices" label="储存设备">
            <a-input v-model="localForm.others.storage_devices" />
          </a-form-model-item>
          <a-form-model-item prop="storage_temperature" label="存储温度">
            <a-input v-model="localForm.others.storage_temperature" />
          </a-form-model-item>
          <a-form-model-item prop="contact" label="联系人">
            <a-input v-model="localForm.others.contact" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="localForm.others.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="localForm.others.email" />
          </a-form-model-item>
          <a-form-model-item prop="address" label="地址">
            <a-input v-model="localForm.others.address" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="localForm.others.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { monitorsAdd, monitorsEdit } from "@/api/refrigerate";

export default {
  name: "FormModal",
  props: {
    visible: Boolean,
    form: Object,
    clientsClassificationOptions: Array,
  },
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 64, message: "超出最大长度 (64)", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入编号", trigger: "blur" },
          { max: 32, message: "超出最大长度 (32)", trigger: "blur" },
        ]
      },
      loading: false,
      localVisible: this.visible,
      localForm: JSON.parse(JSON.stringify(this.form)),
    };
  },
  watch: {
    visible(v) { this.localVisible = v; },
    form(v) { this.localForm = JSON.parse(JSON.stringify(v)); },
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.localForm.id ? monitorsEdit : monitorsAdd;
          func(this.localForm)
            .then(() => {
              this.$message.success(this.localForm.id ? "修改成功" : "新增成功");
              this.$emit(this.localForm.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if(!this.localForm.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style scoped></style>
